import React from "react";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import "@aws-amplify/ui-react/styles.css";
import "./styles/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import {
  Vehicles,
  VehicleGroups,
  ImageRepofragment,
  Deployments,
  Configurations,
  Logs,
  Users,
  Commands,
  Dashboard,
  Releases,
  Reports,
} from "./fragments";
import reportWebVitals from "./reportWebVitals";
import Image from "./routes/Image";
import Vehicle from "./routes/Vehicle";
import Release from "./routes/Release";
import Deployment from "./routes/Deployment";
import User from "./routes/User";
import { useState } from "react";
import { VehicleDeploymentDetails } from "./components/vehicle";
import { Auth, Hub } from "aws-amplify";
import { AmplifyProvider, Authenticator } from "@aws-amplify/ui-react";
import { orange, grey } from "@mui/material/colors";

import JwtInterceptor from "./auth/JwtInterceptor";

import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import { WizardProvider } from "./components/wizard/Context";
import { ToastProvider } from "./components/toast/Context";
import ProtectedRoute from "./auth/ProtectedRoute";
import { configureAmplify } from "./auth/AmplifyHelper";
import { AppLogo } from "./components/common/AppLogo";
import { Typography } from "@mui/material";
import VehicleGroup from "./routes/VehicleGroup";
import Configuration from "./routes/Configuration";
import ProvisioningReport from "./components/reports/ProvisioningReport";
import SchedulerReport from "./components/reports/SchedulerReport";
import NavigationReport from "./components/reports/NavigationReport";
import DeploymentsReport from "./components/reports/DeploymentsReport";
import ValidateRoute from "./routes/ValidateRoute";
import {
  Button,
  View,
  Flex,
  Text,
  Divider,
  Alert,
} from "@aws-amplify/ui-react";
import LastSeenReport from "./components/reports/LastSeenReport";
import { IDP_PROVIDERS, IDP_ERRORS } from "./services/Constants";
console.log("pointing to environment ", process.env.REACT_APP_STAGE);

configureAmplify();

// Add Jwt interceptor to add authorization bearer token in the axios header
JwtInterceptor();

// You can get the current config object
const currentConfig = Auth.configure();
console.log("Other change ::", currentConfig);

// SAML
let isEmailValidationVisible = false;
let isGroupValidationVisible = false;
Hub.listen("auth", (data) => {
  console.log("data.payload.event");
  if (data.payload.event === "signIn_failure") {
    let msg = data.payload.data.message;
    let customErrorMsgForEmail = msg.search("UsernameExistsException");
    isEmailValidationVisible = customErrorMsgForEmail > -1 ? true : false;
    let customErrorMsgForGroup = msg.search("UserGroupNotExists");
    isGroupValidationVisible = customErrorMsgForGroup > -1 ? true : false;
  }
});

export default function AppRouter() {
  const [socket, setSocket] = useState(null);

  const [vehicleSearchToggle, setVehicleSearchToggle] = useState(() => {
    const mode = localStorage.getItem("vehicleSettingsMode");
    if (mode === "true") {
      return true;
    } else if (mode === "false") {
      return false;
    } else {
      return true;
    }
  });

  /*useEffect(() => {
    const socket = io(Constants.SOCKET_URL);

    socket.on("connect", () => {
      console.log("socket connected");
      console.log(`socket id ${socket.id}`);
      const engine = socket.io.engine;
      console.log(engine.transport.name); // in most cases, prints "polling"
    });

    socket.on("disconnect", () => {
      console.log(`socket disconnected ${socket.id}`);
    });

    setSocket(socket);
    return () => socket.close();
  }, [setSocket]);*/

  const amplifyTheme = {
    name: "my-theme",
    tokens: {
      components: {
        button: {
          // this will affect the font weight of all button variants
          fontWeight: { value: "{fontWeights.black.value}" },
          // style the primary variation
          primary: {
            backgroundColor: { value: "#ef6c00" },
            _hover: {
              backgroundColor: { value: orange[700] },
            },
          },
        },
      },
    },
  };

  // Create a client
  const queryClient = new QueryClient();
  const queryDebugger = process.env.REACT_APP_DEBUGGER || false;

  const AuthPageHeader = () => {
    return (
      <div style={{ marginBottom: "3em" }}>
        <AppLogo />
      </div>
    );
  };

  const AuthViewComponents = {
    Header() {
      return <AuthPageHeader />;
    },
    // SignIn: {
    //   Header() {
    //     return <AuthPageHeader />;
    //   },
    // },
    // SignUp: {
    //   Header() {
    //     return <AuthPageHeader />;
    //   },
    // },
  };

  const customAuth = {
    SignIn: {
      Header() {
        return (
          <View textAlign="center" style={{ padding: "40px 32px" }}>
            <Flex direction="column" alignItems="center" gap="1.5rem">
              {/* Orange Logo Icon */}

              <div
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className="logoicon orange"
                  style={{ width: "100%", height: "100%" }}
                ></div>
              </div>

              {/* Title */}
              <Text
                fontSize="1.5rem"
                fontWeight="600"
                color="#333"
                style={{ marginTop: "0.5rem" }}
              >
                OTA Portal
              </Text>

              {/* Subtitle */}
              <Text fontSize="0.9rem" color="#666">
                Sign in with your organization account
              </Text>

              {/* SSO Button */}
              <Button
                name="visteon"
                fontWeight="500"
                isFullWidth={true}
                variation="primary"
                size="large"
                onClick={() => {
                  federatedSignInUpdateUser();
                }}
                style={{
                  marginTop: "1rem",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontSize: "1rem",
                }}
              >
                Sign in with SSO
              </Button>

              {/* Error Alerts */}
              {isEmailValidationVisible && (
                <div
                  style={{
                    marginTop: "1rem",
                    width: "100%",
                    padding: "16px",
                    backgroundColor: "#FFF3F3",
                    border: "1px solid #FFCDD2",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      backgroundColor: "#EF5350",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      boxShadow: "0 2px 8px rgba(239, 83, 80, 0.3)",
                    }}
                  >
                    {/* Error circle with exclamation */}
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                  </div>
                  <div>
                    <Text
                      fontSize="0.875rem"
                      color="#C62828"
                      fontWeight="600"
                      style={{ marginBottom: "4px" }}
                    >
                      {IDP_ERRORS.ACCOUNT_CONF}
                    </Text>
                    <Text fontSize="0.8rem" color="#E53935">
                      {IDP_ERRORS.ACCOUNT_CONF_MSG}
                    </Text>
                  </div>
                </div>
              )}
              {isGroupValidationVisible && (
                <div
                  style={{
                    marginTop: isEmailValidationVisible ? "0.5rem" : "1rem",
                    width: "100%",
                    padding: "16px",
                    backgroundColor: "#FFF8E1",
                    border: "1px solid #FFE082",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      backgroundColor: "#FFA000",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      boxShadow: "0 2px 8px rgba(255, 160, 0, 0.3)",
                    }}
                  >
                    {/* Lock/Shield icon for access denied */}
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                    </svg>
                  </div>
                  <div>
                    <Text
                      fontSize="0.875rem"
                      color="#E65100"
                      fontWeight="600"
                      style={{ marginBottom: "4px" }}
                    >
                      {IDP_ERRORS.ACCESS_DENIED}
                    </Text>
                    <Text fontSize="0.8rem" color="#F57C00">
                      {IDP_ERRORS.ACCESS_DENIED_MSG}
                    </Text>
                  </div>
                </div>
              )}
            </Flex>
          </View>
        );
      },
      Footer() {
        return (
          <View textAlign="center" style={{ padding: "16px 32px 32px" }}>
            <Text fontSize="0.75rem" color="#999">
              © 2025 Visteon. All rights reserved.
            </Text>
          </View>
        );
      },
    },
  };

  // Custom CSS to hide the default sign-in form fields
  const hideFormStyles = `
    [data-amplify-authenticator] [data-amplify-form] {
      display: none !important;
    }
    [data-amplify-authenticator] [data-amplify-router] {
      border: none;
      border-radius: 16px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
      background: white;
      max-width: 400px;
    }
  `;

  const federatedSignInUpdateUser = async () => {
    try {
      // Determine the correct provider based on environment
      const provider =
        process.env.REACT_APP_STAGE === "local" ||
        process.env.REACT_APP_STAGE === "dev"
          ? IDP_PROVIDERS.VISTEONIDP
          : IDP_PROVIDERS.HDIDP;

      // Initiate federated sign-in with the selected provider
      await Auth.federatedSignIn({ provider });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CssBaseline>
      <style>{hideFormStyles}</style>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AmplifyProvider theme={amplifyTheme}>
            <Authenticator
              hideSignUp={true}
              //loginMechanisms={["email"]}
              //signUpAttributes={["name", "email", "phone_number"]}
              className="auth-container"
              components={customAuth}
              // components={AuthViewComponents}
            >
              {({ signOut, user }) => (
                <BrowserRouter>
                  <WizardProvider>
                    <Routes>
                      <Route
                        path="*"
                        element={
                          <ValidateRoute user={user}>
                            <App />
                          </ValidateRoute>
                        }
                      >
                        <Route exact path="/*" element={<Dashboard />} />
                        <Route
                          path="vehicles"
                          element={
                            <Vehicles
                              vehicleSearchToggle={vehicleSearchToggle}
                              setVehicleSearchToggle={setVehicleSearchToggle}
                            />
                          }
                        />
                        <Route
                          path="vehicles/:vehicleId/*"
                          element={<Vehicle socket={socket} />}
                        />
                        <Route path="groups" element={<VehicleGroups />} />
                        <Route
                          path="groups/:groupId/*"
                          element={<VehicleGroup />}
                        />
                        <Route path="releases" element={<Releases />} />
                        <Route
                          path="releases/:releaseId/*"
                          element={<Release />}
                        />
                        <Route path="images" element={<ImageRepofragment />} />
                        <Route path="images/:imageId/*" element={<Image />} />
                        <Route path="deployments" element={<Deployments />} />
                        <Route
                          path="deployments/:deploymentId/*"
                          element={<Deployment />}
                        />
                        <Route
                          path="deployments/:deploymentId/vehicle/:vehicleId"
                          element={<VehicleDeploymentDetails />}
                        />
                        <Route
                          path="configurations"
                          element={<Configurations />}
                        />
                        <Route
                          path="custom-configurations"
                          element={<Configurations />}
                        />
                        <Route
                          path="custom-configurations/:configId/*"
                          element={<Configuration />}
                        />
                        <Route path="commands" element={<Commands />} />
                        <Route path="logs" element={<Logs />} />
                        <Route
                          path="users/myprofile/*"
                          element={
                            <User
                              isMyProfile={true}
                              vehicleSearchToggle={vehicleSearchToggle}
                              setVehicleSearchToggle={setVehicleSearchToggle}
                            />
                          }
                        />
                        <Route
                          path="users/*"
                          element={
                            <ProtectedRoute>
                              <Users isMyProfile={false} user={user} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="reports/provisioning"
                          element={<ProvisioningReport />}
                        />
                        <Route
                          path="reports/scheduler"
                          element={<SchedulerReport />}
                        />
                        <Route
                          path="reports/navigation"
                          element={<NavigationReport />}
                        />
                        <Route
                          path="reports/deployment"
                          element={<DeploymentsReport />}
                        />
                        <Route
                          path="reports/lastseen"
                          element={<LastSeenReport />}
                        />
                        <Route
                          path="*"
                          element={
                            <main style={{ padding: "1rem" }}>
                              <p>There's nothing here!</p>
                            </main>
                          }
                        />
                      </Route>
                    </Routes>
                    {queryDebugger && (
                      <ReactQueryDevtools initialIsOpen={false} />
                    )}
                  </WizardProvider>
                </BrowserRouter>
              )}
            </Authenticator>
          </AmplifyProvider>
        </QueryClientProvider>
      </ToastProvider>
    </CssBaseline>
  );
}

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
